module.exports = __webpack_public_path__ + "img/8-oneImg.ec2d9294.png";